import { object, string } from 'yup'

export const actionFeatureSchema = (agentsFlagOn: boolean) => {
  const validationShape = {
    name: string()
      .min(2, `${agentsFlagOn ? 'Capability' : 'Feature'} name must be at least 2 characters`)
      .required(`Enter a name for your ${agentsFlagOn ? 'capability' : 'feature'}`)
  }
  return object().shape(validationShape)
}
